import { forwardRef } from "react";
import { Radio } from "antd";

const UBKRadio = forwardRef(({ error, success, disabled, ...rest }, ref) => (
  // console.log("ssasas",""+rest.label),

  <div className="form-group">
    {rest.label &&
      <div>
        <label className="labelfont">{rest.label}</label>
      </div>
    }
    <Radio.Group {...rest} ref={ref} disabled={disabled}/>

    {/* <input className="btn btn-primary btn-sm" {...rest} ref={ref} /> */}
  </div>
));

export default UBKRadio;
